import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {DxButtonModule, DxPopupModule, DxScrollViewModule, DxTextBoxModule, DxToastModule} from 'devextreme-angular';
import {CtlTemHesapAramaComponent} from './ctl-tem-hesap-arama/ctl-tem-hesap-arama.component';
import {TemHesapService} from './ctl-tem-hesap.service';
import {CommonModule} from '@angular/common';
import {CtlSablonComponent} from '../ctl-sablon/ctl-sablon.component';
import {LabelMode} from 'devextreme/common';
import {UtilsService} from '../../../services/utils.service';
import {OrtakService} from '../../../services/ortak.service';
import {DkGlobalUserSettingsService} from '../../../services/dk-global-user-settings.service';
import {ControlConditionModel} from "../../../models/gen-control.model";
import {CtlGenKontrolAramaComponent} from "../ctl-gen-kontrol/ctl-gen-kontrol-arama/ctl-gen-kontrol-arama.component";

@Component({
  selector: 'dk-ctl-tem-hesap',
  templateUrl: './ctl-tem-hesap.component.html',
  styleUrls: ['./ctl-tem-hesap.component.scss'],
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CtlTemHesapAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    DxToastModule,
    CtlSablonComponent,
    CtlGenKontrolAramaComponent,
  ],
  providers: [TemHesapService],
})
export class CtlTemHesapComponent implements OnInit {
  @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  @Input() labelText = "";
  @Input() labelMode: LabelMode = this.globalSettings.globalLabelMode;
  public toastVisible = false;
  public showAction = true;
  public crudPopupVisible = false;
  public toastMessage: string;
  public title!: string;
  public isFirst = true;
  public control!: any;
  controlName = "TemHesap";
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  @Input() isReadonlyViewBtn = true;
  public data: any;
  @Input() code!:any;
  @Input() baseEntity: string;
  @Input() isShowViewBtn = false;
  @Input() codeStart!: string | string[];
  @Input() labelWidth!: string;
  @Input() period!: number;
  @Input() isMainAccount = true;
  @Input() onlyMainAccount = false;
  filterColumn = "HesapKod";
  public filterColumnValue: any;
  @Input() type = "string";
  @Input() conditionColName: any;
  @Input() conditionColText: any;
  @Input() controlCondition: ControlConditionModel[];
  @Input() notContain = false;
  @Input() selectLastNode = false;
  @Input() key!: string;
  @Input() accountCodeLength: number;
  @Input() validationRulesMap: any[] = [];
  @Input() validationV2 = false;
  @Input() warningMessage: string | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();
  @Output() viewButtonClicked: EventEmitter<any> = new EventEmitter();

  isEnterPressed = false;

  constructor(private service: TemHesapService, private utilsService: UtilsService, private ortakService: OrtakService,
              private globalSettings: DkGlobalUserSettingsService
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['period']) {
      if (this.period == null) {
        this.showAction = false
      } else {
        this.showAction = true
        this.service.setParams(this.period, this.isMainAccount, this.codeStart, this.accountCodeLength, this.controlCondition, this.notContain, this.baseEntity, this.onlyMainAccount,this.isReadOnly,this.isBindCheck)
      }
    }
    if (changes['controlCondition']) {
      this.service.setParams(this.period, this.isMainAccount, this.codeStart, this.accountCodeLength, this.controlCondition, this.notContain, this.baseEntity, this.onlyMainAccount,this.isReadOnly,this.isBindCheck)
    }
        if (changes['isReadOnly'] || changes['isBindCheck']) {
      this.service.setParams(this.period, this.isMainAccount, this.codeStart, this.accountCodeLength, this.controlCondition, this.notContain, this.baseEntity, this.onlyMainAccount,this.isReadOnly,this.isBindCheck)
          }
  }

  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }
    if (!this.period) {
      this.toastMessage = "Lütfen Dönem Bilgisini Kontrol Ediniz.(Tem Hesap)"
      this.showAction = false
    }
      this.service.setParams(this.period, this.isMainAccount, this.codeStart, this.accountCodeLength, this.controlCondition, this.notContain, this.baseEntity, this.onlyMainAccount,this.isReadOnly,this.isBindCheck)
  }

  getControl() {
    this.ortakService.getControl(this.controlName)
      .subscribe((data) => {
        this.control = data?.controlMetadata;
        //this.service.getDlist(this.control?.dlistCode);
        this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
        //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if (data?.controlMetadata.dlistMetadata.baseEntity) {
          if (this.labelText === "") this.labelText = this.control.controlDescription;
          if (this.code && this.control) this.getData(this.code, true)
          if (this.isFirst) this.isFirst = false;
        }
      });
  }


  searchClick() {
    if (this.showAction) this.crudPopupVisible = true
    else this.toastVisible = true
  }

  clear() {
    this.title = '';
    this.code = null;
    this.data = null;
    this.filterColumnValue = ''
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if (this.showAction) {
      if (e === '' || e === null) this.clear();
      else if(e?.length > 0 && this.isFirst) this.getData(e);
      else if (!this.isFirst) this.getData(e);
      this.isFirst = false;
    } else this.toastVisible = true
  }



  getData(code: string, isSetData?: boolean, setType?: string) {
    this.data = this.service.getData(code,this.control, this.period, this.isMainAccount, this.codeStart, this.baseEntity ? this.baseEntity : this.control.dlistMetadata.baseEntity, null, isSetData);
    // DKM-5042 Clara: veri servisi (vwDaBDataController, SortByPrimaryKey=false) sıralama verilmezse ORDER BY'sız,
    // DB planına bağlı sırada ve 10'luk sayfa döndürüyor. 'startswith' süzgecinde tam eşleşen kod en kısa önek olduğundan
    // HesapKod sırasıyla her zaman ilk sayfanın başına gelir.
    this.data.sort('HesapKod');
    this.data.load().then((result: any) => {
      if (result.length === 1 && code) {
        this.isFirst = true
        this.title = result[0].Ad;
        this.code = result[0].HesapKod;
        this.dataResult.emit(result[0]);
      }
      if (result.length > 1 && code ) {
        // DKM-5042 Clara: eski hâli — tam eşleşmeyi yalnız ilk satırda arıyordu; sıra müşteri DB'sine göre değişince
        // (ör. Osmaniye, Hesap Planı'nda KBS Hesap Kodu '100') ekran açılırken "Hesap Arama" popup'ı açılıyordu.
        // if (result[0].HesapKod === code && !this.selectLastNode) {
        //   this.title = result[0].Ad;
        //   this.code = result[0].HesapKod;
        //   this.dataResult.emit(result[0]);
        // } else {
        const tamEslesen = result.find((r: any) => r?.HesapKod === code);
        if (tamEslesen && !this.selectLastNode) {
          this.title = tamEslesen.Ad;
          this.code = tamEslesen.HesapKod;
          this.dataResult.emit(tamEslesen);
        } else {
          this.filterColumnValue = code;
          this.searchClick();
        }
      }
      if (result.length === 0 && this.code.length > 0) {
        this.utilsService.showError('Hesap Bulunamadı');
        this.clear();
      }
    })
  }


  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      if(!this.selectLastNode){
        this.isFirst = true
        this.title = result.data.Ad;
        this.data = result.data;
        this.code = result.data.HesapKod;
        this.dataResult.emit(this.data);
        this.filterColumnValue = ''
      } else {
        this.getData(result.data.HesapKod)
      }
    }
    this.filterColumnValue = ''
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });

  }
  viewButtonlick($event: any) {
    this.viewButtonClicked.emit($event);
  }

}
